<div class="content">
    <div class="visual" showin [showDelay]="80">
        <img ngSrc="/images/home/veyora-join-email.webp" width="640" height="640"
            alt="Veyora Fit activewear newsletter essentials">
    </div>
    <div class="texts">
        <p>Veyora Circle</p>
        <h2>Join the list before the next drop lands.</h2>
        <span>Enjoy 10% off your first order, early access to new sets, and fit notes before each launch.</span>
    </div>
    <div class="input">
        <input (keydown.enter)="join()" [(ngModel)]="email" maxlength="100" placeholder="Email address"
            aria-label="Email address">
        <button matButton="outlined" (click)="join()">Join</button>
    </div>
</div>